import { render, staticRenderFns } from "./TheCapsule.vue?vue&type=template&id=7f28d708&"
import script from "./TheCapsule.vue?vue&type=script&lang=js&"
export * from "./TheCapsule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports